export var IdAssetBundleHarbor;
(function (IdAssetBundleHarbor) {
    IdAssetBundleHarbor["Harbor_1"] = "Harbor_1";
})(IdAssetBundleHarbor || (IdAssetBundleHarbor = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/outskirts/IdAssetBundleHarbor.ts
// module id = 2138
// module chunks = 3